import {  ForkJoinObservable  } from './ForkJoinObservable';

export const forkJoin = ForkJoinObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/forkJoin.ts